(function (scope, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (!scope.MemoMindBlogData?.loadArticles) {
    scope.MemoMindBlogData = api;
    document.dispatchEvent(new CustomEvent('memomind:blog:data-ready'));
  }
})(typeof window === 'undefined' ? globalThis : window, function () {
  'use strict';
  const uniqueSources = (sources) => [...new Map(sources.filter((source) => source && source.handle && source.url).map((source) => [source.handle, source])).values()];
  const articleKey = (article) => String(article.id || article.url);

  async function loadArticles(sources, fetcher = globalThis.fetch, baseUrl = globalThis.location?.href || 'https://local.invalid/', signal) {
    const sourceList = uniqueSources(sources);
    const result = [];
    let next = 0;
    async function worker() {
      while (next < sourceList.length) {
        const source = sourceList[next++];
        let pages = 1;
        let total = null;
        const sourceArticles = [];
        for (let page = 1; page <= pages; page++) {
          const url = new URL(source.url, baseUrl);
          if (url.origin !== new URL(baseUrl).origin) throw new Error('Article feeds must be on the storefront origin');
          url.search = '';
          const previewTheme = new URL(baseUrl).searchParams.get('preview_theme_id');
          if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
          url.searchParams.set('view', 'memomind-data');
          url.searchParams.set('page', String(page));
          const controller = new AbortController();
          const abort = () => controller.abort();
          signal?.addEventListener('abort', abort, { once: true });
          if (signal?.aborted) controller.abort();
          const timeout = setTimeout(abort, 15000);
          let data;
          try {
            const response = await fetcher(url.href, { signal: controller.signal, credentials: 'same-origin', headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error('Article feed request failed');
            data = await response.json();
          } finally {
            clearTimeout(timeout);
            signal?.removeEventListener('abort', abort);
          }
          if (!data || data.blog?.handle !== source.handle || Number(data.page) !== page || !Array.isArray(data.articles)) throw new Error('Invalid article feed');
          if (!Number.isInteger(Number(data.pages)) || Number(data.pages) < 0 || Number(data.pages) > 500 || !Number.isInteger(Number(data.total)) || Number(data.total) < 0 || Number(data.total) > 25000) throw new Error('Article feed exceeds supported pagination');
          if (total !== null && total !== Number(data.total)) throw new Error('Article feed changed during loading');
          total = Number(data.total);
          pages = Math.max(1, Number(data.pages));
          for (const article of data.articles) {
            if (!article || !article.id || !article.url || typeof article.title !== 'string' || !Number.isFinite(Date.parse(article.published_at))) throw new Error('Invalid article data');
            sourceArticles.push({ ...article, tags: Array.isArray(article.tags) ? article.tags : [], tag_handles: Array.isArray(article.tag_handles) ? article.tag_handles : [], blog_handle: source.handle, blog_title: source.title });
          }
        }
        const unique = [...new Map(sourceArticles.map((article) => [articleKey(article), article])).values()];
        if (unique.length !== total) throw new Error('Incomplete article feed');
        result.push(...unique);
      }
    }
    await Promise.all(Array.from({ length: Math.min(3, sourceList.length) }, worker));
    return [...new Map(result.map((article) => [articleKey(article), article])).values()];
  }
  return { loadArticles };
});
